import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';

@Injectable()
export class LtiHelperService {
    constructor(
        private http: HttpClient,
        private apiGatewayHelperService: ApiGatewayHelperService

    ) {}

    requestDeepLinkingForm(ltik, resourceData) {
        return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'lti/deeplink', { ltik, resourceData }).toPromise();
    }
    //to delete asignment from LTI class
    deleteAssignmentFromClass(spaceId, classId, assignmentId) {
        return this.http.delete(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/class/' + classId + '/assignment/' + assignmentId);
    }

}